import {useContext, useEffect, useState} from "react";
import Spinner from "../../Spinner";
import purchaseOrderContext from "../../../contexts/purchaseOrders/purchaseOrderContext";
import Error from "../../alerts/Error";

function ArchivePurchaseOrder ({purchaseOrder}) {
	const {archivePurchaseOrder, unarchivePurchaseOrder, loading} = useContext(purchaseOrderContext);
	const [error, setError] = useState(null);

	useEffect(() => {
		return () => {
			const backdrops = document.getElementsByClassName("modal-backdrop fade show");
			for (let i = 0; i < backdrops.length; i++) {
				backdrops[i].remove();
			}
		}
	}, []);

	async function onSubmit(evt) {
		evt.preventDefault();
		setError(null);

		try {
			if (purchaseOrder.archived) {
				await unarchivePurchaseOrder(purchaseOrder.id);
			}
			else {
				await archivePurchaseOrder(purchaseOrder.id);
			}
		}
		catch (e) {
			console.error(e);
			setError(e.message);
		}
	}

	return (
		<>
			<button className={"btn btn-warning btn-sm"} data-bs-toggle={"modal"} data-bs-target={"#archivePurchaseOrderModal" + purchaseOrder.id}>{purchaseOrder.archived ? 'Unarchive' : 'Archive'} purchase order</button>
			<div className={"modal fade"} id={"archivePurchaseOrderModal" + purchaseOrder.id} tabIndex="-1" aria-labelledby={"archivePurchaseOrderModalLabel" + purchaseOrder.id} aria-hidden="true">
				<div className={"modal-dialog"}>
					<div className={"modal-content"}>
						<form onSubmit={onSubmit}>
							<div className={"modal-header"}>
								<h5 className={"modal-title"} id={"archivePurchaseOrderModalLabel" + purchaseOrder.id}>{purchaseOrder.archived ? 'Unarchive' : 'Archive'} purchase order</h5>
								<button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} />
							</div>
							<div className={"modal-body"}>
								{error && <Error message={error} /> }
								<span>Are you sure you want to {purchaseOrder.archived ? 'unarchive' : 'archive'} PO {purchaseOrder.number}?</span>
							</div>
							<div className={"modal-footer justify-content-between"}>
								<button type={"button"} className={"btn btn-secondary"} data-bs-dismiss={"modal"}>Close</button>
								<button type={"submit"} className={"btn btn-warning"}>{loading ? <Spinner />: purchaseOrder.archived ? 'Unarchive' : 'Archive'} purchase order</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</>
	)
}

export default ArchivePurchaseOrder;
